import React from 'react';
import {
  ConfirmationContainer,
  ConfirmationFooter,
  ConfirmationMessage,
  ConfirmationTitle,
} from './style';
import Button from 'components/button';
import { WithMargin } from 'components/layout';
import { useTranslation } from 'i18n';

export interface RevokeConfirmationMessageProps {
  isLoading: boolean;
  surfaceName?: string;
  sharedRootSurfaceName?: string;
  onCancel: Function;
  onConfirm: Function;
}

const defaultProps = {};

function RevokeConfirmationMessage(props: RevokeConfirmationMessageProps) {
  const { t } = useTranslation();

  return (
    <ConfirmationContainer>
      <ConfirmationTitle>{t('Are you sure?')}</ConfirmationTitle>
      <ConfirmationMessage>
        {t(
          'This surface {{currentSurface}} is shared via its parent. You will revoke access up to {{sharedSurfaceRoot}}. Are you sure you want to continue?',
          {
            replace: {
              sharedSurfaceRoot: props?.sharedRootSurfaceName,
              currentSurface: props?.surfaceName,
            },
          },
        )}
      </ConfirmationMessage>
      <ConfirmationFooter>
        <WithMargin right="16px">
          <Button label={t('Cancel')} secondary onClick={props.onCancel} />
        </WithMargin>
        <Button
          label={t('Revoke')}
          loading={props.isLoading}
          onClick={props.onConfirm}
        />
      </ConfirmationFooter>
    </ConfirmationContainer>
  );
}

RevokeConfirmationMessage.defaultProps = defaultProps;

export default RevokeConfirmationMessage;
